export default __webpack_public_path__ + "static/media/grafema_martini-contest_06.08140f32.jpg";